"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOW_TOOLBAR_SHEPHERD = exports.SET_USER_ATTRIBUTE = exports.GET_USER_ATTRIBUTES = exports.Icons = exports.MenuTypes = exports.ToolbarControlTypes = void 0;
var ToolbarControlTypes = {
  BUTTON: 'BUTTON',
  SELECT: 'SELECT',
  DIVIDER: 'DIVIDER',
  MORE_MENU: 'MORE_MENU',
  ADVANCED_MENU: 'ADVANCED_MENU',
  INSERT_MENU: 'INSERT_MENU'
};
exports.ToolbarControlTypes = ToolbarControlTypes;
var MenuTypes = [ToolbarControlTypes.ADVANCED_MENU, ToolbarControlTypes.INSERT_MENU, ToolbarControlTypes.MORE_MENU];
exports.MenuTypes = MenuTypes;
var Icons = {
  hscta: 'ctas',
  media: 'embed',
  hspersonalize: 'contacts',
  hsmore: 'readMore',
  hsvideoinsert: 'insertVideo',
  hsvideocombinedinsert: 'insertVideo',
  hstableV2insert: 'table',
  canvascallout: 'spacer',
  hsrsstokens: 'socialRss',
  hsanchor: 'anchor',
  anchor: 'anchor',
  hr: 'horizontalRule',
  nonbreaking: 'nonbreakingSpace',
  charmap: 'specialCharacter'
};
exports.Icons = Icons;
var GET_USER_ATTRIBUTES = 'GET_USER_ATTRIBUTES';
exports.GET_USER_ATTRIBUTES = GET_USER_ATTRIBUTES;
var SET_USER_ATTRIBUTE = 'SET_USER_ATTRIBUTE';
exports.SET_USER_ATTRIBUTE = SET_USER_ATTRIBUTE;
var SHOW_TOOLBAR_SHEPHERD = 'SHOW_TOOLBAR_SHEPHERD';
exports.SHOW_TOOLBAR_SHEPHERD = SHOW_TOOLBAR_SHEPHERD;